import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import queryString from "query-string";
import { useCentralStore } from "stores";

export const deleteMessages = ({ churchId, messageIds }) => {
  const messageIdQueries = queryString.stringify(
    { id: messageIds },
    { arrayFormat: "index" }
  );

  return axios.delete(`/churches/${churchId}/messages?${messageIdQueries}`);
};

export const useDeleteMessages = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["messages"]);
      queryClient.invalidateQueries(["send-messages"]);
      setNotification({
        type: "success",
        message: "Messages deleted successfully!"
      });
      closeDeleteModal();
    },
    ...config,
    mutationFn: deleteMessages
  });
};
